import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { createLanguageSort, LanguageSort } from 'web-shared/utils';

export const useLanguageBasedSort = (options?: Intl.CollatorOptions): { sort: LanguageSort } => {
  const { i18n } = useTranslation();

  const optionsKey = JSON.stringify(options ?? {});
  const sort = useMemo(
    () => createLanguageSort(i18n.language, options),
    [i18n.language, optionsKey]
  );

  return { sort };
};
